import styled from 'styled-components';

export const Container = styled.div`
  border-top: 1px solid var(--border);
  padding: 16px 24px 10px;
  background: var(--background);
  color: var(--text);
`;
